import React from 'react'

import { getAllUser } from 'src/axious/user'
import { handleAxiosError } from 'src/utils/errorHandling'

import { User } from '../user.types'

export const useGetAllUsers = () => {
  const [allUsers, setAllUsers] = React.useState<User[]>([])

  React.useEffect(() => {
    const getAllUsers = async () => {
      try {
        const res: any = await getAllUser()
        setAllUsers(res.data)
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getAllUsers()
  }, [])

  return { allUsers }
}
